/**
 * Created by soundview on 3/5/15.
 */
var Model = require('./model');
var PageableCollection = require('models/base/pageable-collection');
module.exports = PageableCollection.extend({
	// Mixin a synchronization state machine.
	// initialize: function() {
	//   _.extend(this, Chaplin.SyncMachine);
	//   Chaplin.Model.prototype.apply(this, arguments);
	//   this.on('request', this.beginSync);
	//   this.on('sync', this.finishSync);
	//   this.on('error', this.unsync);
	// }
	url: '/index.php/api/v1/clients',
	model: Model,
	mode: 'server',
	// Place your application-specific collection features here
	//parse: function (data) {
	//	return data.data;
	//},
	parseState: function (data, queryParams, state, options) {

		var state = {
			currentPage: data.current_page,
			lastPage: data.last_page,
			totalPages: data.last_page,
			from: data.from,
			to: data.to,
			totalRecords: data.total
		};
		this.trigger('stateParsed', state, this);
		return state;
	},
	parseRecords: function (data) {
		return data.data;
	},
	search: function(search){
		if (search == "") return this;

		var pattern = new RegExp(search, "gi");
		return _(this.filter(function (data) {
			console.log(pattern.test(data.get('name')));
			return pattern.test(data.get("name"));
		}));

		this.trigger('search', pattern, this);
	},
	state: {
		// You can use 0-based or 1-based indices, the default is 1-based.
		// You can set to 0-based by setting ``firstPage`` to 0.
		firstPage: 1,
		//currentPage: 1,
		status: 'all',
		// Required under server-mode
		//totalRecords: 200,
		clientId: null,
		pageSize: 15
	},
	queryParams: {

		// `Backbone.PageableCollection#queryParams` converts to ruby's
		// will_paginate keys by default.
		//currentPage: "current_page",
		//pageSize: "page_size",
		//lastPage: "last_page",
		//totalRecords: "total"
		clientId: null,
		totalPages: 'last_page',
		status: "all"
	},
	search: function (search) {
		if (search == "") return this;

		var pattern = new RegExp(search, "gi");
		return _(this.filter(function (data) {
			return pattern.test(data.get("name"));
		}));
	}

});